<mat-tab-group mat-align-tabs="center" id="tab-config">

    <mat-tab label="Impressão">
        <div class="impressora-config">
            <h1>Configurações da Impressão</h1>
            <input type="checkbox" name="sem-impressora" id="">
            <label for="sem-impressora">Não uso/não tenho impressora</label>
            <h4>Ative essa função se você não usa impressora para imprimir seus pedidos.</h4>

            <h3>Selecione o fabricante da impressora:</h3>
            <h4>Selecione o fabricante da sua impressora, geralmente, a informação pode ser encontrada na parte frontal da impressora.</h4>
            <select name="impressoras" id="">
                <option value="0" selected>Selecione uma opção</option>
                <option value="1">HP Print</option>
                <option value="2">Bematech</option>
                <option value="3">Multilaser</option>
            </select>

            <h3>Selecione a impressora:</h3>
            <h4>Selecione a impressora instalada no seu Windows, caso você não a encontre, certifique-se de que a impressora foi instalada corretamente</h4>
            <select name="impressoras" id="">
                <option value="0" selected>Selecione uma opção</option>
                <option value="1">HP Print</option>
                <option value="2">Bematech</option>
                <option value="3">Multilaser</option>
            </select>

            <h3>Selecione a quantidade de colunas na impressão:</h3>
            <h4>Use esse campo para definir a largura da impressão. Cada coluna é ocupada por</h4>
            <select name="impressoras" id="">
                <option value="0" selected>Selecione uma opção</option>
                <option value="1">HP Print</option>
                <option value="2">Bematech</option>
                <option value="3">Multilaser</option>
            </select>
        </div>
    </mat-tab>

    <mat-tab label="Som">
        <div class="som-notificacao">
            <div class="opcao-som">
                <div class="input-form">
                    <h1>Exibição e notificação</h1>
                    <h3>Permanência dos Pedidos no Monitor após Concluído:</h3>
                    <h4>Selecione o tempo em que os pedidos poderão ser vizualidados no monitor</h4>
                    <select class="selector">
                        <option value="1d">Até às 23h59</option>
                        <option value="15m">15 minutos</option>
                        <option value="30m">30 minutos</option>
                        <option value="60m">1 hora</option>
                        <option value="2h">2 horas</option>
                        <option value="3h">3 horas</option>
                        <option value="4h">4 horas</option>
                        <option value="5h">5 horas</option>
                        <option value="6h">6 horas</option>
                        <option value="8h">8 horas</option>
                        <option value="12h">12 horas</option>
                        <option value="24h" selected="1">24 horas</option>
                        <option value="48h">48 horas</option>
                        <option value="72h">72 horas</option>
                    </select>
                </div>

                <div class="input-form">
                    <h3>Notificação a tocar quando receber novo pedido:</h3>
                    <h4>Selecione o som de notificação que mais te agrada. Este som será reproduzido a cada novo pedido que chegar</h4>
                    <select class="selector">
                        <option value="sound_7" selected="1">sound_7</option>
                        <option value="sound_8">sound_8</option>
                        <option value="sound_6">sound_6</option>
                        <option value="sound_4">sound_4</option>
                        <option value="sound_3">sound_3</option>
                        <option value="sound_2">sound_2</option>
                        <option value="sound_1">sound_1</option>
                        <option value="sound_5">sound_5</option>
                        <option value="default">default</option>
                    </select>
                </div>

                <div class="input-form">
                    <h3>Volume:</h3>
                    <h4>Selecione o volume em que o a notificação será reproduzida</h4>
                    <select class="selector">
                        <option value="0.25">25%</option>
                        <option value="0.5">50%</option>
                        <option value="0.75">75%</option>
                        <option value="1" selected="1">100%</option>
                    </select>
                </div>

                <div class="input-form">
                    <h3>Repetir:</h3>
                    <h4>Selecione a quantidade de vezes que o som será reproduzido a cada novo pedido que chegar</h4>
                    <select class="selector">
                        <option value="1" selected="1">1 vez</option>
                        <option value="2">2 vezes</option>
                        <option value="3">3 vezes</option>
                        <option value="4">4 vezes</option>
                        <option value="5">5 vezes</option>
                    </select>
                </div>
            </div>
        </div>
    </mat-tab>

</mat-tab-group>